import { createContext, useContext } from "react";

import type { ProductRoomI18nFormModel } from "../../model/type";

type QueryData = ProductRoomI18nFormModel["QueryData"];
type ViewModel = ProductRoomI18nFormModel["ViewModel"];

export type ProductRoomI18nFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const ProductRoomI18nFormModelContext = createContext<ProductRoomI18nFormModelContextType | null>(null);

export const useProductRoomI18nFormModelContext = () => {
	const context = useContext(ProductRoomI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductRoomI18nFormModelContext must be used within a ProductRoomI18nFormModelContext.Provider",
		);
	}

	return context;
};
